import type { Column } from '@rundown-studio/types'

/**
 * Determines if a column is a private notes column accessible to a specific user.
 *
 * @param {Pick<Column, 'name' | 'privateUid'>} column - The column to check, containing name and `privateUid` properties
 * @param {string} [userId] - Optional user ID to check against the column's `privateUid`
 * @returns {boolean} - `true` if the column is a private notes column and belongs to the specified user
 */
export const getIsPrivateNotesColumn = (
  column: Pick<Column, 'name' | 'privateUid'>,
  userId?: string,
): boolean => {
  return (
    column.name.toLowerCase().includes('private notes') &&
    userId === column.privateUid
  )
}
